import config from 'BRAND/config';

const hasFeature = (store) => {
  return {
    inserted: function (el, binding, vnode) {
      const userAuthorities = store.getters.getUserAccount ? store.getters.getUserAccount.authorities : [];
      if (hasAuthorities(userAuthorities, binding.value)) {
        return;
      }
      vnode.elm.parentElement.removeChild(vnode.elm);
    }
  };
};

const hasAnyFeature = (store) => {
  return {
    inserted: function (el, binding, vnode) {
      const features = binding.value;
      const userAuthorities = store.getters.getUserAccount ? store.getters.getUserAccount.authorities : [];
      for (let feature of features) {
        if (hasAuthorities(userAuthorities, feature)) {
          return;
        }
      }
      vnode.elm.parentElement.removeChild(vnode.elm);
    }
  };
};

const hasAuthorities = (userAuthorities, feature) => {
  const featurePermission = config.featurePermission.find(obj => {
    return obj.feature === feature;
  });
  if (!featurePermission || !featurePermission.authorities || !userAuthorities) {
    return false;
  }

  // requiresOneOf: legacy single-tier gate. User must hold at least one of these.
  // Kept for backwards compatibility — used for admin-only items (Variables,
  // Consultas, Users/Permisos) where there is a single allowed class of user.
  if (featurePermission.requiresOneOf) {
    const meetsRequirement = featurePermission.requiresOneOf.some(
      required => userAuthorities.includes(required)
    );
    if (!meetsRequirement) {
      return false;
    }
  }

  // requiresAnyOf: multi-tier gate. Array of arrays. User must hold at least one
  // authority from at least one inner array. Used when several disjoint classes of
  // users should see the feature (e.g. admins/nutris OR vibers, but never bare
  // prescriptors). Each inner array represents an allowed "user class". Adding a
  // new class is purely additive — no negative checks involved.
  if (featurePermission.requiresAnyOf) {
    const meetsAnyClass = featurePermission.requiresAnyOf.some(
      requiredClass => requiredClass.some(
        required => userAuthorities.includes(required)
      )
    );
    if (!meetsAnyClass) {
      return false;
    }
  }

  for (let authority of featurePermission.authorities) {
    for (let userAuth of userAuthorities) {
      if (authority === userAuth) {
        return true;
      }
    }
  }
  return false;
};

export default {
  hasFeature,
  hasAnyFeature
};



// WEBPACK FOOTER //
// ./src/directives/featureToggleDirective.js